<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista de agentes</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :to="{ path: `/guardar-agente` }"
                    :loading="isloading"
                    :disabled="isloading"
                    color="orange darken-1"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text"
                        >mdi-account-plus-outline</v-icon
                    >
                </v-btn>
            </template>
            <span>Nuevo agente</span>
        </v-tooltip>
        <v-row>
            <v-col cols="12" md="4">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-data-table
            :item-class="
                () => {
                    return 'pointer';
                }
            "
            @click:row="
                (item) => {
                    $router.push(`/guardar-agente?id=${item.id}`);
                }
            "
            dense
            :headers="headers"
            :items="Agentes"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
        >
            <template v-slot:item.fecha_alta="{ item }">
                <span>{{ item.created_at | format_date }}</span>
            </template>
            <template v-slot:item.nomina_bruto="{ item }">
                <span>{{ item.nomina_bruto | format_precio }}</span>
            </template>
            <template v-slot:item.action="{ item }">
                <a @click.stop="openModal(item)">
                    <v-icon
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="BORRAR"
                        >mdi-trash-can</v-icon
                    >
                </a>
            </template>
        </v-data-table>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
export default {
    data() {
        return {
            search: "",
            headers: [
                { text: "Agente", value: "nombre", sortable: false },
                { text: "DNI", value: "usuario.dni", sortable: false },
                { text: "Fecha de alta", value: "fecha_alta", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            Agentes: [],
            selectedItem: 0,
            dialog: false,
        };
    },
    created() {
        this.getAgentes();
    },
    methods: {
        getAgentes() {
            axios.get(`api/get-agentes`).then(
                (res) => {
                    this.Agentes = res.data.Agentes;
                },
                (err) => {
                    this.$custom_error("Error consultando los agentes");
                }
            );
        },
        openModal(item) {
            this.selectedItem = this.Agentes.indexOf(item);
            this.dialog = true;
        },
        deleteUser() {
            axios
                .post("api/delete-agente", {
                    id: this.Agentes[this.selectedItem].id,
                })
                .then(
                    (res) => {
                        this.$toast.sucs("Agente eliminado con éxito");
                        this.dialog = false;
                        this.getAgentes();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el agente");
                    }
                );
        },
    },
    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
    },
};
</script>
